import React, { useEffect, useState } from 'react'

import HSAReimbursement from './HSAReimbursement'
import ICHRAReimbursement from './ICHRAReimbursement'

type ReimbursementType = 'HSA' | 'ICHRA'

interface ReimbursementFormProps {
  hasHSA: boolean;
  hasICHRA: boolean;
  hasQMEAvailable: boolean;
  maxHSABalance: number;
  maxICHRABalance: number;
  maxICHRABalanceLastYear: number;
}

type ReimbursementTypeOptions = {
  label: string
  value: string
}

const MemberOneOffReimbursementsForm = ({
  hasHSA,
  hasICHRA,
  hasQMEAvailable,
  maxHSABalance,
  maxICHRABalance,
  maxICHRABalanceLastYear,
}: ReimbursementFormProps) => {
  const [reimbursementType, setReimbursementType] = useState<ReimbursementType | ''>('')
  const canFileReimbursement = hasHSA || hasICHRA
  const [reimbursementOptions, setReimbursementOptions] = useState<ReimbursementTypeOptions[]>([])
  useEffect(() => {
    function getInitialReimbursementType () {
      if (hasHSA && hasICHRA) {
        return setReimbursementType('')
      }
      if (hasICHRA) {
        return setReimbursementType('ICHRA')
      }

      return setReimbursementType('HSA')
    }

    function getInitialReimbursementOptions () {
      const options: ReimbursementTypeOptions[] = []
      if (hasICHRA) {
        options.push({ label: 'Thatch balance', value: 'ICHRA' })
      }
      if (hasHSA) {
        options.push({ label: 'HSA', value: 'HSA' })
      }

      setReimbursementOptions(options)
    }
    getInitialReimbursementType()
    getInitialReimbursementOptions()
  }, [hasHSA, hasICHRA])

  return (
    <div className='space-y-6 bg-white rounded-2xl border border-gray-200 shadow-sm p-6'>
      <h2 className='heading-md'>Reimbursement details</h2>
      <div>
        <label className='label-default'>
          {canFileReimbursement && hasHSA && (
            <>
              Reimbursement type
              <select
                className='input-default mt-2'
                name='reimbursement[type]'
                value={reimbursementType}
                onChange={(e) => {
                  setReimbursementType(e.target.value as ReimbursementType)
                }}
              >
                <option value=''>Select</option>
                {reimbursementOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </>
          )}
          {(!canFileReimbursement) && 'You must have an HSA account or have opted in to ICHRA to submit a reimbursement.'}
        </label>

        {reimbursementType === 'HSA' && (
          <HSAReimbursement maxHSABalance={maxHSABalance} />
        )}
        {reimbursementType === 'ICHRA' && (
          <ICHRAReimbursement hasQMEAvailable={hasQMEAvailable} maxICHRABalance={maxICHRABalance} maxICHRABalanceLastYear={maxICHRABalanceLastYear} />
        )}
      </div>
    </div>
  )
}

export default MemberOneOffReimbursementsForm
